import Logo, { eLogo } from '../Observodon/components/Logo/Logo';
import React, { useState } from 'react';

import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import { DocRoutes } from '../common/DocRoutes';
import IconButton from '@mui/material/IconButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PracticeLogo from '../Practice/Logo';
import { PracticeRoutes } from '../common/PracticeRoutes';
import SettingsIcon from '@mui/icons-material/Settings';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import SubjectIcon from '@mui/icons-material/Subject';
import { UiRoutes } from '../common/UiRoutes';
import { canLogin } from '../config';

/** Links available on the top level menu. */
interface IMenuLink {
  /** Title of link displayed in the menu. */
  title: string;
  /** Link target. */
  href: string;
  /** Optional icon to display. */
  icon?: JSX.Element | (() => JSX.Element);
  /** Optional description. */
  description?: string;
  /** Optional value indicating that a login is required. */
  private?: boolean;
}

const links: IMenuLink[] = [
  {
    title: 'Home',
    href: '/',
    icon: <Logo height={18} logo={eLogo.icon} />,
    description: 'Observodon home page'
  },
  {
    title: `Practice`,
    href: PracticeRoutes.HOME,
    icon: <PracticeLogo size={16} />,
    description: 'Example medical practice',
    private: true
  },
  {
    title: `Trial`,
    href: UiRoutes.TRIAL,
    icon: <AddToHomeScreenIcon />,
    description: 'Launch the Observodon trial demo',
    private: true
  },
  {
    title: 'Docs',
    href: DocRoutes.DOCS,
    icon: <SubjectIcon />,
    description: 'API routes, authorization, and setup'
  },
  {
    title: 'Samples',
    href: UiRoutes.SAMPLE_HOME,
    icon: <SlideshowIcon />,
    description: 'Demo requests to API endpoints'
  },
  {
    title: 'Admin',
    href: UiRoutes.ADMIN,
    icon: <SettingsIcon />,
    description: 'Administrator settings (requires login)',
    private: true
  }
];

const TopMenu = () => {
  const [anchor, setAnchor] = useState<HTMLElement | undefined>();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchor(event.currentTarget);
  };
  const handleClose = () => {
    setAnchor(undefined);
  };
  const open = !!anchor;

  return (
    <div>
      <IconButton
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <MenuIcon color="secondary" />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchor}
        anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
      >
        {links
          .filter((link) => !link.private || canLogin)
          .map((link) => {
            const renderIcon =
              typeof link.icon === 'function'
                ? (link.icon as Function)()
                : link.icon;
            return (
              <MenuItem
                key={link.href}
                component="a"
                href={link.href}
                style={{ verticalAlign: 'middle' }}
              >
                {link.icon && (
                  <ListItemIcon style={{ minWidth: 56 }}>
                    {renderIcon as React.ReactNode}{' '}
                    {/* Force cast to ReactNode to satisfy React 18 types */}
                  </ListItemIcon>
                )}
                <ListItemText>{link.title}</ListItemText>
              </MenuItem>
            );
          })}
      </Menu>
    </div>
  );
};

export default TopMenu;
